import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { ProductChannel } from '../../../consts/Common';
import { SiteContext } from '../../../context/SiteContext';
import { ProductFilter } from '../../common/CommonTypes';
import { getFormattedDate } from '../../common/HelperMethods';
import ProductManager from '../../common/ProductPage/ProductManager';
import { useJourney } from '../Layout';
import { LocationQuote, LocationVehicleId } from './CustomerVehicleDetailsPage';

type LocationState = LocationQuote;

const CustomerProductPage = (): JSX.Element => {
  const { site } = useContext(SiteContext);
  const { user } = site;
  const cms = site.content.productPage;
  const {
    journey,
    onUpdateProducts,
    onUpdateProductDocuments,
    setIsExpiredMessageAcknowledged
  } = useJourney();

  const {
    products,
    vehicle,
    quoteProducts,
    hasQuoteExpired,
    isExpiredMessageAcknowledged,
    isOpensiteUser,
    quoteId,
    expiryDetails
  } = journey;

  console.log(products);

  const { state } = useLocation();

  const isCCWUser = !!site.user?.userId;

  const setIsMessageAcknowledged = () => {
    if (setIsExpiredMessageAcknowledged) {
      setIsExpiredMessageAcknowledged(true);
    }
  };

  const currentDate = new Date();
  const yesterdayDate = currentDate.setDate(currentDate.getDate() - 1);
  const gapDateOpensite = new Date(yesterdayDate).toLocaleDateString('en-GB');
  const defaultVehicleDeliveryDate = new Date(currentDate).toLocaleDateString(
    'en-GB'
  );

  const productFilter: ProductFilter = {
    dealerCode: journey.dealerCode,
    firstRegistrationDate: vehicle.vehicleDetails.registrationDate,
    vehiclePurchaseDate:
      vehicle.vehicleDeliveryDate === undefined
        ? defaultVehicleDeliveryDate
        : getFormattedDate(vehicle.vehicleDeliveryDate),
    vehicleValue: vehicle.vehiclePurchasePrice,
    currentMileage: vehicle.currentMileage ?? 0,
    modelTrimId: vehicle.vehicleDetails.modelTrimId,
    fuelTypeId: vehicle.vehicleDetails.fuelTypeCode,
    engineSize: parseInt(vehicle.vehicleDetails.engineSize),
    enginePowerBHP: vehicle.vehicleDetails.enginePowerBHP ?? 0,
    enginePowerKWH: vehicle.vehicleDetails.enginePowerKWH ?? 0,
    driveTypeId: vehicle.vehicleDetails.driveTypeId?.toString() ?? '',
    vrn: vehicle.vehicleDetails.vrn,
    channel: isOpensiteUser ? ProductChannel.OpenSite : ProductChannel.Customer,
    gapDate:
      isOpensiteUser == true
        ? gapDateOpensite
        : getFormattedDate(vehicle.vehicleGapIntroductionDate) ?? '',
    isOpenSite: isOpensiteUser,
    countryCode: site.countryCode
  };

  const showQuotedPrice = () => {
    if (isCCWUser) {
      return (
        (
          state as LocationState
        )?.quote?.vehicleInfo?.vehicleDetails?.vrn.toUpperCase() ===
        vehicle.vehicleDetails.vrn.toUpperCase()
      );
    } else {
      return true;
    }
  };

  return (
    <ProductManager
      products={products}
      productFilter={productFilter}
      foundExistingQuotes={quoteId > 0}
      cms={cms}
      onUpdateProducts={onUpdateProducts}
      onUpdateProductDocuments={onUpdateProductDocuments}
      token={user.token}
      quoteProducts={quoteProducts}
      hasQuoteExpired={hasQuoteExpired}
      isExpiredMessageAcknowledged={isExpiredMessageAcknowledged}
      setIsExpiredMessageAcknowledged={setIsMessageAcknowledged}
      showKeyBenefits={!isCCWUser}
      showKeyBenefitsInProductCard={true}
      showQuotedPrice={showQuotedPrice()}
      expiryDetails={expiryDetails}
      vehicleIdType={(state as LocationVehicleId)?.vehicleIdType}
    />
  );
};

export default CustomerProductPage;
